import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Hephaestus admin module — `/hephaestus` on console.francisquini.ai.
 *
 * Answers the cockpit Tier 1 question "Onde esta o dinheiro do produto
 * e quem esta deixando de pagar?" — see
 * `arkheus/docs/cockpit/dashboards/tier-1-operacional-critico.md §1.2`.
 *
 * Surface is `'admin'` — registered only on the console host. Each page
 * also wraps `<RequireAdmin>` for defence-in-depth on top of the host
 * split. Backend gates every `/v1/{finance,feedback,releases}/admin/*`
 * endpoint on `is_super_admin=true`.
 */
export const manifest: ModuleManifest = {
  module_id: 'hephaestus',
  display_name: 'Hephaestus',
  surface: 'admin',
  routes: [
    {
      path: '/hephaestus',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusHomePage,
        })),
      title: 'Hephaestus — Dashboard',
      permissions: [],
    },
    {
      path: '/hephaestus/finance',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusFinancePage,
        })),
      title: 'Hephaestus — Finance',
      permissions: [],
    },
    {
      path: '/hephaestus/finance/bills/$billId',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusBillDetailPage,
        })),
      title: 'Hephaestus — Bill',
      permissions: [],
    },
    {
      path: '/hephaestus/feedback',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusFeedbackPage,
        })),
      title: 'Hephaestus — Feedback',
      permissions: [],
    },
    {
      path: '/hephaestus/feedback/$id',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusFeedbackDetailPage,
        })),
      title: 'Hephaestus — Feedback item',
      permissions: [],
    },
    {
      path: '/hephaestus/feedback/clusters/$id',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusFeedbackClusterPage,
        })),
      title: 'Hephaestus — Cluster',
      permissions: [],
    },
    {
      path: '/hephaestus/releases',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusReleasesPage,
        })),
      title: 'Hephaestus — Releases',
      permissions: [],
    },
    {
      path: '/hephaestus/releases/$id',
      component: () =>
        import('@/routes/_app/hephaestus').then((m) => ({
          default: m.HephaestusReleaseDetailPage,
        })),
      title: 'Hephaestus — Release',
      permissions: [],
    },
  ],
}
